// extracted by mini-css-extract-plugin
export default {"Container":"taskItem_Container__Ii+Ro"};